export default __webpack_public_path__ + "static/media/icon-teams.3ea9396f.svg";